import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { STATES_BY_ABBREVIATION, USStates } from '@lc/core';
import { TextboxComponent } from '../../../inputs/textbox/textbox.component';
import { AddressDetailsFormComponent } from '../address-details-form/address-details-form.component';
import { ResponsiveClassDirective } from '../../../core/directives/responsive-class.directive';
import { PhoneNumberComponent } from '../../../inputs/phone-number/phone-number.component';

@Component({
  selector: 'lc-address-information-form',
  templateUrl: './address-information-form.component.html',
  styleUrls: ['./address-information-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextboxComponent,
    AddressDetailsFormComponent,
    ResponsiveClassDirective,
    PhoneNumberComponent,
  ],
})
export class AddressInformationFormComponent {
  readonly states: USStates[] = STATES_BY_ABBREVIATION;
  @Input() formGroup: FormGroup;
}
